import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Center from '../../assets/styles/Center';
import DefaultContainer from '../../assets/styles/DefaultContainer';
import Error from '../../components/Error';
import Loader from '../../components/Loader';
import { useRecordModelVisit } from '../../hooks/mutations/useModelMutations';
import { useModelTop } from '../../hooks/queries/useModels';
import { useStore } from '../../stores';
import { saveToStorage } from '../../utils/saveToStorage';
import About from './components/About';
import Banner from './components/Banner';
import Bottom from './components/Bottom';
import GroupAbout from './components/GroupAbout';
import Review from './components/Review';
import Service from './components/Service';
import Uploads from './components/Uploads';
import * as styles from './styles';

export default function Model() {
  const theme = useTheme();
  const { id } = useParams();
  const user = useStore((state) => state.user);

  // Queries compartilhadas
  const {
    data: modelData,
    isLoading: isLoadingModel,
    isError: isErrorModel,
    error: errorModel,
  } = useModelTop(id);

  // Mutation register Visit db
  const recordVisit = useRecordModelVisit();

  // Register Visit
  useEffect(() => {
    if (id) {
      recordVisit.mutate(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Save on localStorage model
  useEffect(() => {
    function saveToHistoric(modelStorage) {
      const key =
        process.env.REACT_APP_LOCAL_STORAGE_HISTORIC || 'flamehot_historic';

      saveToStorage(key, modelStorage);
    }

    if (modelData && user?.type === 'client') {
      const model = {
        id,
        city: modelData.city,
        fantasyName: modelData.fantasyName,
      };
      saveToHistoric(model);
    }
  }, [modelData, user, id]);

  // Loading e Error
  const isLoadingShared = isLoadingModel;
  const isErrorShared = isErrorModel;
  const errorShared = errorModel;

  if (isLoadingShared) {
    return <Loader isLoading={isLoadingShared} />;
  }

  if (isErrorShared) {
    return (
      <Error isError message={isErrorShared.message || errorShared.message} />
    );
  }

  return (
    <DefaultContainer $background={theme.colors.gradient[180]}>
      <Center className="center">
        <styles.ModelBody>
          <Banner />
          <About />
          <GroupAbout />
        </styles.ModelBody>

        <Uploads />
        <Service />
        <Review />
        <Bottom />
      </Center>
    </DefaultContainer>
  );
}
